module.exports = __webpack_public_path__ + "img/testimonial-10-61x61_1testimonial-10-61x61.8a2cb294.png";